// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ro-c";
export var backButton = "_ro-4";
export var backIcon = "_ro-5";
export var chevronShortcut = "_ro-6";
export var container = "_ro-1";
export var editor = "_ro-8";
export var editorWrapper = "_ro-7";
export var prefix = "_ro-2";
export var searchIcon = "_ro-3";
export var suffix = "_ro-9";
export var suffixContent = "_ro-a";
export var suffixText = "_ro-b";
export var wrapper = "_ro-0";